export interface IPastAPI {
  Id: string;
  TsExternalId: string;
  TotalPages: number;
  Page: number;
  Size: number;
  Matches: Match[];
}

export interface Match {
  Id: string;
  TsExternalId: string;
  MatchDate: string;
  CompetitionName: string;
  CompetitionNameTranslation: Record<string, string> | null;
  CompetitionLogo: string;
  HomeName: string;
  HomeNameTranslation: Record<string, string> | null;
  HomeLogo: string;
  HomeScore: number;
  HomePenaltyScore: number | null;
  AwayName: string;
  AwayNameTranslation: Record<string, string> | null;
  AwayLogo: string;
  AwayScore: number;
  AwayPenaltyScore: number | null;
  Result: string;
}

export enum EPastType {
  HOME = 'HOME',
  AWAY = 'AWAY',
  H2H = 'H2H',
}

export enum EResult {
  WIN = 'WIN',
  LOSE = 'LOSS',
  DRAW = 'DRAW',
}
